
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/password",
      function () {
        return require("private-next-pages/account/password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/password"])
      });
    }
  